import React from "react";

export default function PostChoiceModal({
  isOpen,
  onClose,
  onPostNow,
  onSchedule,
  title = "Post",
  hint
}) {
  if (!isOpen) return null;

  return (
    <div
      className="modal block"
      tabIndex="-1"
      style={{
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "fixed",
        inset: 0,
        zIndex: 1050,
      }}
    >
      <div className="modal-dialog modal-sm" style={{ margin: 0 }}>
        <div className="modal-content">
          <div className="modal-header" style={{ justifyContent: "center", position: "relative" }}>
            <h5 className="modal-title" style={{ color: "#253866", textAlign: "center", width: "100%" }}>{title}</h5>
            <button type="button" className="btn-close" onClick={onClose} style={{ position: "absolute", right: "1rem" }} />
          </div>
          <div className="modal-footer" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.5rem" }}>
            <div className="flex gap-2" style={{ justifyContent: "center" }}>
              <button className="btn btn-primary" onClick={onPostNow}>Post Now</button>
              <button className="btn btn-primary" onClick={onSchedule}>Schedule</button>
            </div>
            <button className="btn btn-secondary" style={{ width: "100%" }} onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
}
